export const LOCK_STATUS_UPDATE = (state, status) => {
    state.lockStatus = status;
};
